<template>
  <div class="csqbox">
    <h2 class="header">房产交易税费计算器</h2>
    <div class="itembox">
      <div class="item">
        <label></label>
        <span>
          <van-radio-group v-model="form.radio" direction="horizontal" @change="radioChange">
            <van-radio name="存量房" icon-size="16px">存量房(二手房)</van-radio>
            <van-radio name="增量房" icon-size="16px">增量房(一手房)</van-radio>
          </van-radio-group>
        </span>
      </div>
      <div class="item">
        <label>房屋性质：</label>
        <span>
          <van-radio-group v-model="form.fwxz" direction="horizontal">
            <van-radio name="住宅" icon-size="16px">住宅</van-radio>
            <van-radio name="非住宅" icon-size="16px">非住宅</van-radio>
          </van-radio-group>
        </span>
      </div>
      <div class="item" v-if="form.radio=='存量房'&&form.fwxz=='住宅'">
        <label>房屋年限：</label>
        <span @click="show=true">{{form.fwnx}} <img src="@/assets/image/index_more.png"></span>
      </div>
      <div class="item" v-if="form.radio=='存量房'&&form.fwxz=='住宅'">
        <label>是否卖方唯一住宅：</label>
        <span>
          <van-radio-group v-model="form.sfmfwyzz" direction="horizontal">
            <van-radio name="是" icon-size="16px">是</van-radio>
            <van-radio name="否" icon-size="16px">否</van-radio>
          </van-radio-group>
        </span>
      </div>
      <div class="item" v-if="(form.radio=='存量房'&&form.fwxz=='住宅') || (form.radio=='增量房'&&form.fwxz=='住宅')">
        <label>买方房屋数量：</label>
        <span>
          <van-field v-model="form.fwsl" input-align="right" placeholder="请输入房屋数量" type="digit" />
        </span>
      </div>
      <div class="item" v-if="(form.radio=='存量房'&&form.fwxz=='住宅') || (form.radio=='增量房'&&form.fwxz=='住宅')">
        <label>房屋建筑面积：</label>
        <span style="display: flex;align-items: center;">
          <van-field v-model="form.fwjzmj" style="margin-right: 8px;" input-align="right" placeholder="请输入房屋建筑面积" type="digit" />㎡
        </span>
      </div>
      <div class="item" v-if="form.radio=='增量房'&&form.fwxz=='非住宅'">
        <label>房屋合同签订日期：</label>
        <span @click="dateShow=true">{{form.htqdrq}} <img src="@/assets/image/index_more.png"></span>
      </div>
      <div class="item">
        <label>房屋总价：</label>
        <span style="display: flex;align-items: center;">
          <van-field v-model="form.fwzj" style="margin-right: 8px;" input-align="right" placeholder="请输入房屋总价" type="digit" />元
        </span>
      </div>
    </div>
    <h3 v-if="isShowJsjg">计算结果</h3>
    <div class="itembox" v-if="(parseFloat(zzs)+parseFloat(tdzzs)+parseFloat(fjsf)+parseFloat(grsds)+parseFloat(yhsSeller))>0">
      <h4>卖方</h4>
      <div class="item" v-if="zzs>0">
        <label>增值税：</label>
        <span>{{zzs}}元</span>
      </div>
      <div class="item" v-if="tdzzs>0">
        <label>土地增值税：</label>
        <span>{{tdzzs}}元</span>
      </div>
      <div class="item" v-if="fjsf>0">
        <label>附加税费：</label>
        <span>{{fjsf}}元</span>
      </div>
      <div class="item" v-if="grsds>0">
        <label>个人所得税：</label>
        <span>{{grsds}}元</span>
      </div>
      <div class="item" v-if="parseFloat(yhsSeller)>0">
        <label>印花税：</label>
        <span>{{parseFloat(yhsSeller)}}元</span>
      </div>
      <div class="item">
        <label style="color: #f00; font-weight: bold;">卖方合计：</label>
        <span>{{(parseFloat(zzs)+parseFloat(tdzzs)+parseFloat(fjsf)+parseFloat(grsds)+parseFloat(yhsSeller)).toFixed(2)}}元</span>
      </div>
    </div>
    <div class="itembox" v-if="(parseFloat(qs)+parseFloat(yhsBuyer))>0" style="margin-top: 0.24rem">
      <h4>买方</h4>
      <div class="item" v-if="qs>0">
        <label>契税：</label>
        <span>{{qs}}元</span>
      </div>
      <div class="item" v-if="parseFloat(yhsBuyer)>0">
        <label>印花税：</label>
        <span>{{parseFloat(yhsBuyer)}}元</span>
      </div>
      <div class="item">
        <label style="color: #f00; font-weight: bold;">买方合计：</label>
        <span>{{(parseFloat(qs)+parseFloat(yhsBuyer)).toFixed(2)}}元</span>
      </div>
    </div>
    <p class="tips">温馨提示：</p>
    <p class="tips">评估价格与合同价格孰高，按高价计算</p>
    <p class="tips">计算结果仅供参考，精确金额以实际缴纳为准</p>
    <ul class="btn">
      <li><button class="jsbtn" @click="reset('reset')">重置</button></li>
      <li><button class="jsbtn" @click="count">计算</button></li>
    </ul>
    <van-popup position="bottom" v-model="show" :lazy-render="false">
      <van-picker
        ref="myPicker"
        title="选择房屋年限"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="show=false"
      />
    </van-popup>
    <van-popup position="bottom" v-model="dateShow">
      <van-datetime-picker
        v-model="form.currentDate"
        type="date"
        title="选择房屋合同签订日期"
        @confirm="dateConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data(){
    return{
      form:{
        radio:"存量房",
        fwxz:"住宅",
        fwnx:"房产证不满2年",
        sfmfwyzz:"是",
        fwsl:"",
        fwjzmj:"",
        fwzj:"",
        htqdrq:"请选择",
        currentDate:new Date(),//房屋合同签订日期
      },
      show:false,
      columns: ['房产证不满2年', '房产证满2年，不满5年', '房产证满5年'],
      zzs:0,//增值税
      tdzzs:0,//土地增值税
      fjsf:0,//附加税费
      grsds:0,//个人所得税
      qs:0,//契税
      yhsSeller:0,//印花税卖房
      yhsBuyer:0,//印花税买房
      dateShow:false,
      isShowJsjg:false,
    }
  },
  methods:{
    dateConfirm(val){
      this.form.currentDate = val
      var year = val.getFullYear()
      var month = val.getMonth() + 1
      var date = val.getDate()
      this.form.htqdrq = `${year}-${month}-${date}`
      this.dateShow = false
    },
    count(){
      if(this.form.fwxz=="住宅" && !this.form.fwsl){
        this.$toast("请填写房屋数量")
        return
      }
      if(this.form.fwxz=="住宅" && !this.form.fwjzmj){
        this.$toast("请填写房屋建筑面积")
        return
      }
      if(!this.form.fwzj){
        this.$toast("请填写房屋总价")
        return
      }
      if(this.form.radio=='增量房'&&this.form.fwxz=="非住宅" && this.form.htqdrq=='请选择'){
        this.$toast("请选择房屋合同签订日期")
        return
      }
      if(this.form.radio == "存量房" && this.form.fwxz == "住宅"){
        if(this.form.fwjzmj<=90){
          if(this.form.fwsl<3){
            this.qs = (this.form.fwzj*1*0.01).toFixed(2)
          }else{
            this.qs = (this.form.fwzj*3*0.01).toFixed(2)
          }
        }else{
          if(this.form.fwsl==1){
            this.qs = (this.form.fwzj*1.5*0.01).toFixed(2)
          }else if(this.form.fwsl==2){
            this.qs = (this.form.fwzj*2*0.01).toFixed(2)
          }else{
            this.qs = (this.form.fwzj*3*0.01).toFixed(2)
          }
        }
        if(this.form.fwnx == "房产证不满2年"){
          this.zzs = (this.form.fwzj*5*0.01).toFixed(2)
          this.fjsf = (this.form.fwzj*0.25*0.01).toFixed(2)
          this.grsds = (this.form.fwzj*1*0.01).toFixed(2)
        }
        
        if(this.form.fwnx == "房产证满2年，不满5年" || this.form.fwnx == "房产证满5年"){
          this.zzs = 0
          this.fjsf = 0
        }
        if(this.form.fwnx == "房产证满5年" && this.form.sfmfwyzz == "是"){
          this.grsds = 0
        }else{
          this.grsds = (this.form.fwzj*1*0.01).toFixed(2)
        }
      }
      if(this.form.radio == "存量房" && this.form.fwxz == "非住宅"){
        this.zzs = (this.form.fwzj*5*0.01).toFixed(2)
        this.tdzzs = (this.form.fwzj*6*0.01).toFixed(2)
        this.grsds = (this.form.fwzj*1*0.01).toFixed(2)
        this.fjsf = (this.form.fwzj*0.25*0.01).toFixed(2)
        this.yhsSeller = (this.form.fwzj*0.025*0.01).toFixed(2)
        this.yhsBuyer = (this.form.fwzj*0.025*0.01).toFixed(2)
        this.qs = (this.form.fwzj*3*0.01).toFixed(2)
      }else{
        this.tdzzs = 0
        this.yhsSeller = 0
        this.yhsBuyer = 0
      }
      if(this.form.radio == "增量房"){
        this.zzs = 0
        this.tdzzs = 0
        this.grsds = 0
        this.fjsf = 0
      }
      if(this.form.radio == "存量房" && this.form.fwxz == "住宅"){
        this.yhsSeller = 0
        this.yhsBuyer = 0
      }else if(this.form.radio == "增量房" && this.form.fwxz == "住宅"){
        this.yhsSeller = 0
        this.yhsBuyer = 0
        if(this.form.fwjzmj<=90){
          if(this.form.fwsl<3){
            this.qs = (this.form.fwzj*1*0.01).toFixed(2)
          }else{
            this.qs = (this.form.fwzj*3*0.01).toFixed(2)
          }
        }else{
          if(this.form.fwsl==1){
            this.qs = (this.form.fwzj*1.5*0.01).toFixed(2)
          }else if(this.form.fwsl==2){
            this.qs = (this.form.fwzj*2*0.01).toFixed(2)
          }else{
            this.qs = (this.form.fwzj*3*0.01).toFixed(2)
          }
        }
      }else{
        if(this.form.currentDate.getTime()>new Date("2021-9-1").getTime()){
          this.qs = (this.form.fwzj*3*0.01).toFixed(2)
          this.yhsBuyer = (this.form.fwzj*0.025*0.01).toFixed(2)
        }else if(new Date("2021-9-1").getTime()>this.form.currentDate.getTime()>new Date("2019-1-1").getTime() || this.form.currentDate.getTime()==new Date("2021-9-1").getTime() || this.form.currentDate.getTime()==new Date("2019-1-1").getTime()){
          this.qs = (this.form.fwzj*5*0.01).toFixed(2)
          this.yhsBuyer = (this.form.fwzj*0.025*0.01).toFixed(2)
        }else if(this.form.currentDate.getTime()<new Date("2019-1-1").getTime()){
          this.qs = (this.form.fwzj*5*0.01).toFixed(2)
          this.yhsBuyer = (this.form.fwzj*0.05*0.01).toFixed(2)
        }
      }
      this.isShowJsjg = true
    },
    onConfirm(value, index) {
      this.form.fwnx = value
      this.show = false
    },
    reset(type){
      if(type=='reset'){
        this.$set(this.form,'radio','存量房')
        this.$set(this.form,'fwxz','住宅')
      }
      this.zzs = 0
      this.tdzzs = 0
      this.grsds = 0
      this.fjsf = 0
      this.yhsSeller = 0
      this.yhsBuyer = 0
      this.qs = 0
      this.isShowJsjg = false
      this.$set(this.form,'fwnx','房产证不满2年')
      this.$set(this.form,'sfmfwyzz','是')
      this.$set(this.form,'fwsl','')
      this.$set(this.form,'fwjzmj','')
      this.$set(this.form,'fwzj','')
      this.$set(this.form,'htqdrq','请选择')
      this.$set(this.form,'currentDate',new Date())
      this.$refs.myPicker.setColumnIndex(0, 0);
    },
    radioChange(){
      this.reset("change")
    }
  }
}
</script>

<style scoped>
.csqbox{
  min-height: 100%;
  background-color: #f0eff4;
  padding-bottom: 1.5rem;
}
.header{
  background-color: #34bff6;
  line-height: 0.82rem;
  color: #fff;
  text-align: center;
  font-size: 0.3rem;
  box-shadow: 0 0 5px 5px rgba(0,0,0,.1);
}
.itembox{
  background-color: #fff;
  border-bottom: 1px solid #d2d1d7;
  border-top: 1px solid #d2d1d7;
}
.item{
  height: 0.8rem;
  display: flex;
  margin: 0 0.3rem;
  font-size: 0.3rem;
  align-items: center;
  justify-content: space-between;
  line-height: 1.2;
}
.item+.item{
  border-top: 1px solid #d2d1d7;
}
.item span{
  /* flex: 1; */
  text-align: right;
}
.item span img{
  width: 0.16rem;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  top: -2px;
}
h3{
  color: #7c7b80;
  text-align: left;
  padding: 0.3rem 0.3rem 0.16rem;
  font-weight: normal;
}
.jsbtn{
  width: 3rem;
  height: 0.62rem;
  background-color: #007aff;
  color: #fff;
  font-size: 0.24rem;
  border: none;
  border-radius: 0.05rem;
}
.tips{
  font-size: 0.24rem;
  text-align: left;
  padding: 0.2rem 0.3rem 0;
  color: #999;
}
.van-cell{
  padding: 0;
}
.btn{
  position: fixed;
  width: 100%;
  bottom: 0rem;
  text-align: center;
  background: #fff;
  padding: 0.24rem 0;
  border-top: 1px solid #d2d1d7;
}
.btn li{
  display: inline-block;
  margin: 0 0.1rem;
}
h4{
  text-align:left;
  margin: 0 0.3rem;
  padding: 0.32rem 0;
  font-size: 0.4rem;
}
</style>